import { gql } from '@apollo/client'

export const PICOS_COMPLIANCE_CRITERIA_FRAGMENT = gql`
  fragment PicOSProductComplianceCriteria on PicOSProductComplianceCriteria {
    columnName
    values
  }
`
